import { Check } from 'lucide-react';
import { type ReactElement } from 'react';
import { cn } from '@avanta/shared/utils/cn';

interface StepProps {
  id: number;
  label: string;
  active: boolean;
  completed: boolean;
}

export const Step = ({ id, label, active, completed }: StepProps): ReactElement => (
  <div className="flex flex-col items-center w-6 shrink-0">
    <div
      className={cn(
        'w-6 h-6 rounded-full inline-flex items-center justify-center transition-colors',
        active || completed ? 'bg-teal-600 text-white' : 'bg-plum-200 text-white'
      )}
    >
      <span className="text-white text-base font-semibold leading-5">
        {completed ? <Check className="w-4 h-4" /> : id}
      </span>
    </div>
    <span
      className={cn(
        'mt-2 text-xs font-medium leading-4 transition-colors text-center whitespace-nowrap',
        active || completed ? 'text-teal-600' : 'text-plum-200'
      )}
    >
      {label}
    </span>
  </div>
);
